import { BaseError } from './BaseError';

export interface ErrorResponse {
  errors?: { code: string }[];
}

/**
 * Error class for an error raised trying to make an API call
 *
 * @class RequestError
 * @access public
 * @param {string} status - the status code of response
 * @param {string} message - the error message
 * @param {Error}  cause   - the original error
 * @param {object} response - the response error

 */
export class RequestError extends BaseError {
  constructor(
    public status: number,
    message: string,
    cause: Error,
    response: ErrorResponse,
  ) {
    super(message, cause, response);
    this.name = 'RequestError';
    this.response = response;
  }
}
